import { Grid } from "@mui/material";

const RightGrid = ({ children }) => {
  return (
    <Grid item lgr={4}>
      {children}
    </Grid>
  );
};

export default RightGrid;
